import { DeclarationPropertiesViews } from "../../../data/enums/declarationPropertiesViews";
import { DeclarationPropertiesTypes } from "../../../data/enums/declarationPropertiesTypes";
import { OperationPropertyModel } from "../../../models/operations/operationPropertyModel";
import { DeclarationPropertyValueData } from "../../../data/declarationPropertyValueData";
import { PersonStore } from "../../../store/modules/person";
import { OperationsApi } from "fs-pb-vue2/services/api/OperationsApi";
import { getModule } from "vuex-module-decorators";
import Vue from "vue";
import { Prop, Watch } from "vue-property-decorator";

/**Модель представления реквизита операции */
export class BaseOperationPropertyVue extends Vue {
  /** Модель реквизита */
  @Prop() property!: OperationPropertyModel;

  /**Действие */
  @Prop() action!: Function;

  /**блокировка поля */
  @Prop() disable!: boolean;

  @Watch('property.errorText', { immediate: true })
  errorComes(val: string) {
    if (val.length && this.property.Declaration.View === 0) {
      if (!this.$refs[this.property.Declaration.Name]) {
        this.$refs[`form_${this.property.Declaration.Name}`].validate();
      } else {
        this.$refs[this.property.Declaration.Name]?.validate();
      }
    }
  }

  @Watch('objectForm', { immediate: true })
  async modalToggle(val: boolean): void {
    if (val) {
      this.property.SubProperties.forEach(async (prop: OperationPropertyModel) => {
        if (prop.Declaration.Assign) {
          await this.action(prop, this.activeObjectIndex);
        }
      });
    }
  }

  @Watch('activeObjectIndex', { immediate: true })
  indexChanged(val: any) {
    this.property.objectActiveIndex = val;
  }

  @Watch('property.Value', { immediate: true })
  valueChanged(val: any): void {
    if (this.property.Declaration.Type != DeclarationPropertiesTypes.File && this.property.Declaration.Type != DeclarationPropertiesTypes.ObjectsList)
      return;
    if (!val) {
      this.fileObj = null;
    } else if (this.property.Declaration.Type == DeclarationPropertiesTypes.ObjectsList) {
      if (this.ObjectListValues.length) return;
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(val, "text/xml");
      const objects = xmlDoc.getElementsByTagName("object");
      for (let i = 0; i < objects.length; i++) {
        const props = objects[i].getElementsByTagName('properties')[0].getElementsByTagName('property');
        this.ObjectListValues.push([]);
        this.property.SubProperties.forEach((prop: OperationPropertyModel) => {
          let value: string = '';
          for (let j = 0; j < props.length; j++) {
            const proper = props[j];
            if (prop.Declaration.Name == proper.getAttribute('name')) {
              value = proper.getAttribute('value')?.replaceAll("&quot;", '\"')
                .replaceAll("&amp;", "&")
                .replaceAll("&apos;", "'")
                .replaceAll("&lt;", "<")
                .replaceAll("&gt;", ">");
            }
          }
          this.ObjectListValues[this.ObjectListValues.length-1].push({
            key: prop.Declaration.Caption,
            name: prop.Declaration.Name,
            value: value
          })
        });
        // for (let j = 0; j < props.length; j++) {
        //   const prop = props[j];
        //   const propTemp = this.property.SubProperties.find((sProp: any) => sProp.Declaration.Name == prop.getAttribute('name'));
        //   this.ObjectListValues[this.ObjectListValues.length-1].push({
        //     key: propTemp.Declaration.Caption,
        //     name: prop.getAttribute('name'),
        //     value: prop.getAttribute('value')
        //   })
        // }
      }
      this.property.Value = new XMLSerializer().serializeToString(this.getXML(this.ObjectListValues));
    } else {
      this.fileObj = this.historyFiles.find((file: any) => file.name === val.split('\\').pop());
    }
  }

  dateNextVisibility: boolean = false;

  objectForm: boolean = false;

  createObjectMode: boolean = false;

  /**Признак загрузки */
  public loading: boolean = false;

  get personStore(): PersonStore {
    return getModule(PersonStore, this.$store);
  }

  /**Имя параметра */
  get name(): string {
    return this.property.Declaration.Name;
  }

  /**Заголовок поля */
  get caption(): string {
    return this.property.Declaration.Caption;
  }

  /**Признак поиска по списку */
  get find(): boolean {
    return this.property.Declaration.Find;
  }

  /**Признак списка с картинками */
  get image(): boolean {
    return this.property.Declaration.Image;
  }

  /**Признак суммы */
  get isSum(): boolean {
    return this.property.IsSum;
  }

  /**Признак суммы */
  get isPhone(): boolean {
    return this.property.IsPhone;
  }

  /**Валюта */
  get currency(): string {
    return this.property.CurrensySymbol;
  }

  // /**Признак загрузки */
  // get loading(): boolean {
  //   return this.property.AssignLoading;
  // }

  /**Правила проверки */
  get checkRules(): string {
    return this.property.CheckRules;
  }

  /**Максимальная длина */
  get maxLength(): number {
    if (this.property.Declaration.Type === 0)
      return this.property.Declaration.Size;
    return 1000;
  }

  get postfix(): string {
    return this.property.Declaration.Postfix;
  }

  /**Признак многострочности */
  get multiline(): boolean {
    return this.property.Declaration.Multiline;
  }

  /**Признак видимости */
  get isVisible(): boolean {
    return this.property.Declaration.View != DeclarationPropertiesViews.Hidden;
  }

  /**Признак нередактируемости */
  get readonly(): boolean {
    return (
      this.property.Declaration.View == DeclarationPropertiesViews.Readonly ||
      this.disable
    );
  }

  /**Маска поля */
  get mask(): string {
    return this.property.Mask;
  }

  get icon(): boolean {
    return this.property.Declaration.Logo.trim() !== "";
  }

  get logo(): string {
    return this.property.Declaration.Logo;
  }

  async saveObjectValue(): void {
    this.validateForm();
    if (!this.isValid)
      return;
    // if (this.activeObjectIndex === this.ObjectListValues.length) {
    //   this.ObjectListValues.push([]);
    // }
    this.ObjectListValues[this.activeObjectIndex] = [];
    this.property.SubProperties.forEach((prop: OperationPropertyModel) => {
      this.ObjectListValues[this.activeObjectIndex].push({
        key: prop.Declaration.Caption,
        name: prop.Declaration.Name,
        value: prop.Value
      })
    })
    this.property.Value = new XMLSerializer().serializeToString(this.getXML(this.ObjectListValues));
    await this.onBlur();
    this.closeObjectValue(false);
  }

  closeObjectValue(flag: boolean): void {
    this.objectForm = false;
    if (flag && this.createObjectMode) {
      this.ObjectListValues = this.ObjectListValues.slice(0, this.activeObjectIndex);
    }
    this.property.SubProperties.forEach((prop: OperationPropertyModel) => {
      prop.Value = null ?? "";
      return;
    });
    this.activeObjectIndex = null;
    this.createObjectMode = false;
  }

  getXML(obj: any): XMLDocument {
    const doc = document.implementation.createDocument("", "", null);
    const objectsList = doc.createElement("objectslist");
    for (let i = 0; i < this.ObjectListValues.length; i++) {
      const object = doc.createElement("object");
      object.setAttribute('id', i.toString());
      const properties = doc.createElement("properties");
      for (let j = 0; j < this.ObjectListValues[i].length; j++) {
        const prp: any = this.ObjectListValues[i][j];
        const propertyObj = doc.createElement("property");
        let value: string = prp.value && prp.value.Key ? prp.value.Key : prp.value;
        value = value?.replaceAll("&", "&amp;")
          .replaceAll('\"', "&quot;")
          .replaceAll("'", "&apos;")
          .replaceAll("<", "&lt;")
          .replaceAll(">", "&gt;")
          .replaceAll("«", "&quot;")
          .replaceAll("»", "&quot;");
        propertyObj.setAttribute('name', prp.name);
        propertyObj.setAttribute('value', value);
        properties.appendChild(propertyObj);
      }
      object.appendChild(properties);
      objectsList.appendChild(object);
    }
    doc.appendChild(objectsList);

    return doc;
  }

  openObjectList(obj: Array<any>, index: number | null): void {
    this.activeObjectIndex = index;
    this.property.objectActiveIndex = index;
    if (obj) {
      this.property.SubProperties.forEach((prop: OperationPropertyModel) => {
        const needVal = obj ? obj.find((elem: any) => elem.name === prop.Declaration.Name) : null;
        prop.Value = needVal ? needVal.value : null;
      })
    } else {
      if (this.activeObjectIndex === this.ObjectListValues.length) {
        this.ObjectListValues.push([]);
      }
      this.ObjectListValues[this.activeObjectIndex] = [];
      this.property.SubProperties.forEach((prop: OperationPropertyModel) => {
        prop.Value = '' ?? null;
        this.ObjectListValues[this.activeObjectIndex].push({
          key: prop.Declaration.Caption,
          name: prop.Declaration.Name,
          value: prop.Value
        })
      })
      this.property.Value = new XMLSerializer().serializeToString(this.getXML(this.ObjectListValues));
      this.createObjectMode = true;
    }
    this.objectForm = true;
  }

  validateForm(): void {
    try {
      this.isValid = (this.$refs.modal_form as Vue & { validate: () => boolean }).validate();
    } catch (e) {
      console.log("this.$refs.form.validate()", e);
    }
  }

  ObjectListValues: Array<any> = [];

  activeObjectIndex: number | null = null;

  isValid: boolean = false;

  fileObj: any = null;

  historyFiles: Array<any> = [];

  getImage(props: OperationPropertyModel) {
    if (props.Value === "" || props.Value === null) return "";
    return props.Values.filter(
      (val: DeclarationPropertyValueData) => val === props.Value
    )[0].Image;
  }

  toggleDatePicker(flag: boolean) {
    this.dateNextVisibility = flag;
  }

  clearDate() {
    this.property.Value = "";
    if (this.dateNextVisibility) this.toggleDatePicker(false);
  }

  onFocus(): void {
    this.$emit('focused', { prop: this.property });
  }

  async fileLoad(): Promise<void> {
    let res: any = null;
    if (this.fileObj) {
      this.property.Value = await OperationsApi.getFileLink(this.fileObj);
      this.historyFiles.push(this.fileObj);
    }
  }

  /**Действие на блур */
  async onBlur(): Promise<void> {
    
    if (this.property.Declaration.Assign) {
      this.loading = true;
      await this.action(this.property);
      this.$emit('focused', { prop: null });
      this.loading = false;
    }
  }
}
